import { render } from "./StateAbortBuildingAge.vue?vue&type=template&id=eced11d2"
import script from "./StateAbortBuildingAge.vue?vue&type=script&lang=js"
export * from "./StateAbortBuildingAge.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__